/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateGrantsControllerDeleteMutationResponse, TemplateGrantsControllerDelete401, TemplateGrantsControllerDelete403, TemplateGrantsControllerDelete404 } from "../../models/checklistsController/TemplateGrantsControllerDelete";

function getTemplateGrantsControllerDeleteUrl() {
  const res = { method: 'DELETE', url: `/api/v1/checklist-template-grants` as const }  
  return res
}

/**
 * @summary Revoke template grants from a scope
 * {@link /api/v1/checklist-template-grants}
 */
export async function templateGrantsControllerDelete(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateGrantsControllerDeleteMutationResponse, ResponseErrorConfig<TemplateGrantsControllerDelete401 | TemplateGrantsControllerDelete403 | TemplateGrantsControllerDelete404>, unknown>({ method : "DELETE", url : getTemplateGrantsControllerDeleteUrl().url.toString(), ... requestConfig })  
  return res.data
}